module.exports = __webpack_public_path__ + "img/symbol_10.559e6448.png";